<div class="w-full py-3 px-4">
  <div class="flex items-center justify-between mb-4">
    <div class="flex items-center justify-start gap-1 lg:gap-2">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="size-6">
        <mask id="mask0_848_1764" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24" style="mask-type: alpha;">
          <rect width="24" height="24" fill="#C19725"></rect>
        </mask>
        <g mask="url(#mask0_848_1764)">
          <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725"></path>
        </g>
      </svg>
      <img class="size-6 sm:size-8 lg:size-10" src="/assets/images/raw-metal/raw-metal.png" alt="Retail Stock" />
      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">Available Retail Stock List</span>
    </div>
    <div>
      <a routerLink="/add-stock/add-retail-fine-stock-b1"
        class="block cursor-pointer px-3 py-1.5 text-xs sm:text-sm lg:text-base font-semibold text-white bg-c19725 border-2 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center dark:bg-c19725 dark:hover:bg-[#fdffc6]">
        Add New Retail Stock
      </a>
    </div>
  </div>

  <div class="flex flex-wrap lg:flex-nowrap justify-between items-center gap-1 sm:gap-2">
    <div class="flex items-center justify-center md:justify-start gap-1 sm:gap-2">
      <div class="relative flex items-center gap-1 sm:gap-2">
        <label for="rowFilter" class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap">
          Rows :
        </label>
        <select id="rowFilter" [(ngModel)]="visibleRowCount" (change)="updateVisibleRows()"
          class="border border-dcdcdc rounded-[5px] p-1 text-xs sm:text-sm appearance-none !bg-none pr-6 focus:outline-none focus:ring-0 focus:border-c19725">
          <option *ngFor="let count of [5, 10, 20, 30, 40, 50, 100]" [value]="count">
            {{ count }}
          </option>
        </select>
        <div class="absolute inset-y-0 right-1.5 flex items-center pointer-events-none">
          <svg width="10" height="5" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z" fill="#C19725" />
          </svg>
        </div>
      </div>

      <div class="flex items-center gap-1 sm:gap-2">
        <label for="globalSearch" class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap">
          Search :
        </label>
        <input id="globalSearch" type="text" [(ngModel)]="globalSearchText" (ngModelChange)="filterTable()"
          placeholder="Search all columns..."
          class="border border-dcdcdc rounded-[5px] px-3 py-1 text-xs sm:text-sm w-32 lg:w-64 focus:outline-none focus:ring-0 focus:border-c19725" autocomplete="off"/>
      </div>
    </div>

    <div class="flex items-center flex-wrap lg:flex-nowrap justify-center md:justify-end gap-2">
      <button class="bg-[#F20707] text-white text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-[#D20505] hover:shadow-lg transition"
        (click)="downloadPDF()">
        Download PDF
      </button>
      <button class="bg-[#029921] text-white text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-[#027d1b] hover:shadow-lg transition"
        (click)="downloadExcel()">
        Download Excel
      </button>
      <button class="bg-[#0720EC] text-white text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-[#0317C1] hover:shadow-lg transition"
        (click)="downloadJSONAll()">
        Download All JSON
      </button>
      <button class="bg-[#00ad94] text-white text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-[#018975] hover:shadow-lg transition"
        (click)="downloadCSV()">
        Download CSV
      </button>

      <div class="relative inline-block text-left">
        <button (click)="toggleDropdown()" class="bg-[#B92185] text-white text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] hover:bg-[#A21E75] hover:shadow-lg transition">
          Column Visibility
        </button>

        <div *ngIf="showDropdown" class="absolute z-50 mt-2 p-4 bg-white border rounded shadow -left-24 w-64">
          <p class="font-semibold mb-2">Select Columns to Show:</p>

          <label *ngFor="let field of selectedFields" class="block text-sm mb-1">
            <input type="checkbox" [(ngModel)]="field.selected" autocomplete="off"/>
            {{ field.label }}
          </label>

          <div class="mt-3 flex flex-col gap-2">
            <button (click)="selectAllFields()" class="text-sm text-blue-600 hover:underline text-left">
              Select All
            </button>
            <button (click)="deselectAllFields()" class="text-sm text-red-800 hover:underline text-left">
              Deselect All
            </button>
            <button (click)="restoreColumnSelection()" class="text-sm text-gray-600 hover:underline text-left">
              Restore Columns
            </button>

            <button (click)="applyColumnSelection()"
              class="mt-2 bg-blue-600 text-white text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] transition">
              Apply
            </button>
          </div>
        </div>
      </div>
      <button (click)="printTable()"
        class="bg-[#5606b6] text-white text-sm px-4 py-2 rounded-[5px] hover:bg-[#3c0282] hover:shadow-lg transition">
        Print
      </button>
    </div>
  </div>

  <div class="overflow-x-auto whitespace-nowrap hide-scrollbar">
    <table
      class="w-full table border border-b-0 border-[#D9D9D9] border-separate border-spacing-0 bg-white overflow-hidden mt-5">
      <thead class="bg-[#F2F2F2] text-444 text-xs sm:text-sm lg:text-base">
        <tr>
          <th class="p-2 font-medium text-center border-r border-444 last:border-r-0">
            No.
          </th>
          <th *ngFor="let field of selectedFieldss"
            class="p-2 font-medium text-left border-r border-444 last:border-r-0">
            <div class="flex flex-col gap-1 w-32">
              <input type="text" [(ngModel)]="searchValues[field.key]" (click)="$event.stopPropagation()"
                (ngModelChange)="filterTable()" [attr.placeholder]="'Search ' + field.label"
                class="border border-dcdcdc p-1 rounded-[5px] text-xs w-full" autocomplete="off"/>

              <div class="text-xs font-medium text-gray-700 flex items-center gap-1 cursor-pointer select-none"
                (click)="sortBy(field.key)">
                {{ field.label }}
                <svg *ngIf="sortKey === field.key" class="w-3 h-3" viewBox="0 0 24 24">
                  <path *ngIf="sortDirection === 'asc'" d="M12 8l6 6H6z" fill="currentColor" />
                  <path *ngIf="sortDirection === 'desc'" d="M12 16l-6-6h12z" fill="currentColor" />
                </svg>
              </div>
            </div>
          </th>
          <th class="p-2 font-medium text-center border-r border-444 last:border-r-0">
            Action
          </th>
        </tr>
      </thead>
      <tbody class="text-xs sm:text-sm lg:text-base">
        <tr *ngFor="let item of paginatedStockList; let i = index">
          <td class="p-2 border-r border-b border-[#D9D9D9] text-center">
            {{ (currentPage - 1) * itemsPerPage + i + 1 }}
          </td>

          <ng-container *ngFor="let field of selectedFieldss">
            <td class="p-2 border-r border-b border-[#D9D9D9]">
              {{ item[field.key] }}
            </td>
          </ng-container>

        <td class="p-2 border-r border-b border-[#D9D9D9] text-center">
          <div class="flex items-center justify-center gap-1 sm:gap-2">
            <button class="cursor-pointer" routerLink="/retail-stock/edit/{{item.st_id}}">
              <svg
                class="w-4 h-4 sm:w-5 sm:h-5"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.552 4.332L19.5109 8.29075M3.2815 16.452L2.75 21.25L7.54788 20.7185L21.25 7.00912V5.39287L18.6071 2.75H16.9909L3.2815 16.452Z"
                  stroke="#C19725"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.7166 9.23962L8.10638 15.8499"
                  stroke="#C19725"
                  stroke-miterlimit="5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>

              <button class="cursor-pointer p-1" (click)="deleteRetailStock(item.st_id)">
                <svg class="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M14 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M4 7.5H20" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                    stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                    stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </td>
        </tr>
      </tbody>

    </table>
  </div>

  <div class="flex items-center justify-end border-t border-gray-200 bg-white py-3">
    <div class="flex sm:flex-1 sm:items-center sm:justify-end">
      <div>
        <nav class="isolate inline-flex gap-2 -space-x-px rounded-md shadow-xs" aria-label="Pagination">
          <button (click)="goToPreviousPage()" [disabled]="currentPage === 1"
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0">
            <span class="sr-only">Previous</span>
            <svg class="size-6" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
              <path fill-rule="evenodd"
                d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
                clip-rule="evenodd" />
            </svg>
          </button>
          <button *ngFor="let page of pageNumbers" (click)="goToPage(page)"
            [class.bg-c19725]="page === currentPage"
            [class.text-white]="page === currentPage"
            class="relative z-10 inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-sm font-normal text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-c19725">
            {{ page }}
          </button>
          <button (click)="goToNextPage()" [disabled]="currentPage === totalPages"
            class="relative inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0">
            <span class="sr-only">Next</span>
            <svg class="size-6" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
              <path fill-rule="evenodd"
                d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                clip-rule="evenodd" />
            </svg>
          </button>
        </nav>
      </div>
    </div>
  </div>
</div>
